import React from 'react';
import { FaSync } from "react-icons/fa";

const Step4_Review = ({
    vendorData,
    uploaded,
    fileNames,
    agreedTerms,
    setAgreedTerms,
    captcha,
    captchaInput,
    setCaptchaInput,
    generateCaptcha,
    isDisabled,
    vendorOnboardInfo,
    onShowTerms
}) => {

    // Helper to render field value or "N/A"
    const renderValue = (val) => val || <span style={{ color: '#ccc', fontStyle: 'italic' }}>N/A</span>;

    // Helper to render document status
    const renderDocStatus = (isUploaded, fileName) => {
        if (isUploaded) {
            return <span style={{ color: '#059669', fontWeight: '600' }}>✓ {fileName || 'Uploaded'}</span>;
        }
        return <span style={{ color: '#dc2626', fontStyle: 'italic' }}>Not Uploaded</span>;
    };

    // Row styles for the list items
    const rowStyle = {
        display: 'flex',
        padding: '10px 0',
        borderBottom: '1px solid #f3f4f6',
        alignItems: 'baseline',
    };
    const labelStyle = {
        fontWeight: '600',
        color: '#4b5563',
        width: '180px',
        flexShrink: 0,
        fontSize: '13px'
    };
    const valueStyle = {
        color: '#111827',
        fontSize: '14px',
        wordWrap: 'break-word',
        overflowWrap: 'break-word',
        flexGrow: 1
    };

    const sectionTitleStyle = {
        fontSize: '16px',
        fontWeight: '700',
        color: '#1e40af',
        marginBottom: '16px',
        paddingBottom: '10px',
        borderBottom: '2px solid #e2e8f0',
        textTransform: 'uppercase',
        letterSpacing: '0.5px'
    };

    const isStlDigital = vendorOnboardInfo?.company &&
        (vendorOnboardInfo.company.trim().replace('-', '').toLowerCase() === 'stldigital' ||
            vendorOnboardInfo.company.trim().toLowerCase() === 'stl-digital');

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '24px', width: '100%' }}>

            {/* MAIN DETAILS CARD: Perfect 50/50 Split */}
            <div className="vendor-card" style={{ padding: '40px 24px 24px' }}>
                <h3 style={{ position: 'absolute', top: '10px', left: '16px' }}>Registration Summary</h3>

                <div style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: '40px',
                    alignItems: 'start',
                    width: '100%'
                }}>

                    {/* LEFT SIDE (50%): Organization & Legal */}
                    <div>
                        <div style={sectionTitleStyle}>Organization Details</div>
                        <div style={rowStyle}><div style={labelStyle}>Company Name:</div> <div style={valueStyle}>{renderValue(vendorData.firstName)}</div></div>
                        <div style={rowStyle}><div style={labelStyle}>Contact Person:</div> <div style={valueStyle}>{renderValue(vendorData.contactName)}</div></div>
                        <div style={rowStyle}><div style={labelStyle}>Email Address:</div> <div style={valueStyle}>{renderValue(vendorData.email)}</div></div>
                        <div style={rowStyle}><div style={labelStyle}>Phone Number:</div> <div style={valueStyle}>{renderValue(vendorData.phone)}</div></div>
                        <div style={rowStyle}><div style={labelStyle}>Address:</div> <div style={valueStyle}>{renderValue(vendorData.address)}</div></div>
                        <div style={rowStyle}><div style={labelStyle}>City:</div> <div style={valueStyle}>{renderValue(vendorData.city)}</div></div>
                        <div style={rowStyle}><div style={labelStyle}>Postal Code:</div> <div style={valueStyle}>{renderValue(vendorData.postal_code)}</div></div>
                        <div style={rowStyle}><div style={labelStyle}>Country / Region:</div> <div style={valueStyle}>{renderValue(vendorData.country)} / {renderValue(vendorData.region)}</div></div>

                        {/* Legal/Tax Docs in Org Column */}
                        <div style={{ ...rowStyle, marginTop: '10px', backgroundColor: '#f9fafb', padding: '10px 8px', borderRadius: '4px' }}>
                            <div style={labelStyle}>NDA Document:</div>
                            <div style={valueStyle}>{renderDocStatus(uploaded.nda, fileNames.nda)}</div>
                        </div>
                        {isStlDigital && (
                            <div style={{ ...rowStyle, borderBottom: 'none', backgroundColor: '#f9fafb', padding: '10px 8px', borderRadius: '4px' }}>
                                <div style={labelStyle}>PAN Number:</div>
                                <div style={valueStyle}>{renderValue(vendorData.pan_tan)}</div>
                            </div>
                        )}
                    </div>

                    {/* RIGHT SIDE (50%): Banking & Compliance */}
                    <div>
                        <div style={sectionTitleStyle}>Banking Details</div>
                        <div style={rowStyle}><div style={labelStyle}>Account Number:</div> <div style={valueStyle}>{renderValue(vendorData.account_number)}</div></div>
                        <div style={rowStyle}><div style={labelStyle}>IFSC / Swift Code:</div> <div style={valueStyle}>{renderValue(vendorData.ifsc_code)}</div></div>
                        <div style={rowStyle}><div style={labelStyle}>Account Holder:</div> <div style={valueStyle}>{renderValue(vendorData.account_holder_name)}</div></div>
                        <div style={rowStyle}><div style={labelStyle}>Bank Name:</div> <div style={valueStyle}>{renderValue(vendorData.bank_name)}</div></div>
                        <div style={rowStyle}><div style={labelStyle}>Bank City:</div> <div style={valueStyle}>{renderValue(vendorData.bank_city)}</div></div>
                        <div style={rowStyle}><div style={labelStyle}>Bank Country:</div> <div style={valueStyle}>{renderValue(vendorData.bank_country)}</div></div>

                        {/* Compliance Docs in Banking Column */}
                        <div style={{ ...rowStyle, marginTop: '10px', backgroundColor: '#f9fafb', padding: '10px 8px', borderRadius: '4px', borderBottom: 'none' }}>
                            <div style={labelStyle}>Assessment Report:</div>
                            <div style={valueStyle}>{renderDocStatus(uploaded.assessment, fileNames.assessment)}</div>
                        </div>
                    </div>

                </div>
            </div>

            {/* TERMS & CAPTCHA */}
            <div className="vendor-card" style={{ padding: '24px' }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                    <div className="checkbox-wrapper" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <input
                            type="checkbox"
                            id="terms"
                            checked={agreedTerms}
                            onChange={(e) => setAgreedTerms(e.target.checked)}
                            disabled={isDisabled}
                            style={{ width: '22px', height: '22px', cursor: 'pointer' }}
                        />
                        <label htmlFor="terms" style={{ cursor: 'pointer', fontSize: '16px', fontWeight: '500' }}>
                            I agree to the <span
                                onClick={(e) => { e.preventDefault(); e.stopPropagation(); onShowTerms(); }}
                                style={{ color: '#4f46e5', fontWeight: '600', textDecoration: 'underline' }}
                            >
                                Terms and Conditions
                            </span>
                        </label>
                    </div>

                    <div className="captcha-container" style={{ display: 'flex', alignItems: 'center', gap: '20px', flexWrap: 'wrap' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <div className="captcha-display" style={{
                                userSelect: 'none',
                                backgroundColor: '#111827',
                                color: '#fff',
                                padding: '12px 28px',
                                borderRadius: '8px',
                                letterSpacing: '6px',
                                fontWeight: 'bold',
                                fontSize: '24px',
                                fontFamily: 'monospace',
                                boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)'
                            }}>
                                {captcha}
                            </div>
                            <button
                                type="button"
                                className="refresh-captcha"
                                onClick={generateCaptcha}
                                disabled={isDisabled}
                                style={{ padding: '10px', color: '#4f46e5', background: 'none', border: 'none', cursor: 'pointer', fontSize: '22px' }}
                                title="Refresh Captcha"
                            >
                                <FaSync className={isDisabled ? 'fa-spin' : ''} />
                            </button>
                        </div>

                        <input
                            type="text"
                            placeholder="Type characters here"
                            value={captchaInput}
                            onChange={(e) => setCaptchaInput(e.target.value)}
                            disabled={isDisabled}
                            maxLength={6}
                            style={{
                                padding: '14px 20px',
                                borderRadius: '8px',
                                border: '2px solid #d1d5db',
                                width: '220px',
                                fontSize: '18px',
                                outline: 'none',
                                transition: 'border-color 0.2s'
                            }}
                            onFocus={(e) => e.target.style.borderColor = '#4f46e5'}
                            onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Step4_Review;
